import React, { memo } from 'react';
import { Position } from 'reactflow';
import { Tooltip } from 'antd';
import { StopOutlined } from '@ant-design/icons';
import EnhancedHandle from './EnhancedHandle';

const ErrorNode = ({ data, isConnectable, selected }) => {
    // Get error message if available
    const errorMessage = data.config?.message || 'Workflow terminated with error';

    // Show execution count badge if available
    const ExecutionCountBadge = () => {
        if (data.executionCount === undefined) return null;

        return (
            <div style={{
                position: 'absolute',
                top: -8,
                right: -8,
                background: '#1890ff',
                color: 'white',
                borderRadius: '50%',
                width: 22,
                height: 22,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                zIndex: 10
            }}>
                {data.executionCount}
            </div>
        );
    };

    return (
        <Tooltip title={errorMessage}>
            <div
                style={{
                    width: 220,
                    height: 80,
                    position: 'relative',
                    background: selected ? '#fff2f0' : 'white',
                    border: selected ? '1px solid #f5222d' : '1px solid #d9d9d9',
                    borderRadius: '8px 8px 30px 30px', // Rounded bottom corners similar to complete node
                    overflow: 'hidden',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                    fontFamily: 'Arial, sans-serif'
                }}
            >
                <ExecutionCountBadge />

                {/* Header */}
                <div style={{
                    background: '#f5222d',
                    color: 'white',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: '1px solid #d9d9d9'
                }}>
                    <StopOutlined style={{ fontSize: 16, marginRight: 8 }} />
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {data.label || 'Error'}
                    </div>
                </div>

                {/* Content */}
                <div style={{
                    padding: '10px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#f5222d',
                    fontWeight: 'bold',
                    fontSize: '13px'
                }}>
                    {errorMessage.length > 25 ? errorMessage.substring(0, 22) + '...' : errorMessage}
                </div>

                {/* Input handle - enhanced */}
                <EnhancedHandle
                    type="target"
                    position={Position.Top}
                    id="in"
                    style={{
                        top: -6
                    }}
                    color="#f5222d"
                    isConnectable={isConnectable}
                />
            </div>
        </Tooltip>
    );
};

export default memo(ErrorNode);
